export const USED_LOGIN_HYPERLINK_MESSAGE_IDS_KEY =
    'usedLoginHyperlinkMessageIds';

export const isMobileApiLoginUrl = (url?: string | null): boolean =>
    Boolean(url && String(url).includes('mobileApiLogin'));

export const messageHasLoginHyperlink = (message: any): boolean => {
    const links = message?.links;
    if (!Array.isArray(links)) {
        return false;
    }
    return links.some((link: { url?: string | null }) =>
        isMobileApiLoginUrl(link?.url)
    );
};

export const getLatestLoginHyperlinkMessageId = (
    chats: Array<{ messageId?: string; message?: any }>
): string => {
    for (let i = chats.length - 1; i >= 0; i--) {
        const chat = chats[i];
        if (!chat?.messageId || !messageHasLoginHyperlink(chat.message)) {
            continue;
        }
        return String(chat.messageId);
    }
    return '';
};

export const parseUsedLoginHyperlinkMessageIds = (
    value: unknown
): string[] => {
    if (Array.isArray(value)) {
        return value.map(String).filter(Boolean);
    }
    if (typeof value !== 'string' || !value) {
        return [];
    }
    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
            return parsed.map(String).filter(Boolean);
        }
    } catch {
        // Cached as a single message id
    }
    return [value];
};

export const appendUsedLoginHyperlinkMessageId = (
    current: unknown,
    messageId?: string | null
): string[] => {
    const ids = parseUsedLoginHyperlinkMessageIds(current);
    if (!messageId || ids.includes(messageId)) {
        return ids;
    }
    return [...ids, messageId];
};
